import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import UpdateDataModal from "./UpdateDataModal";
import AddDataModal from "./AddDataModal";
import moment from "moment";
import DatePicker from "react-date-picker";
import Pagination from "../../Common/Pagination/Pagination";
import { sweetAlert } from "../../Common/Utills/Utills";
import _ from "lodash";
const Compliances = () => {
  const handle = useFullScreenHandle();
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [error, setError] = useState(null);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [file, setFile] = useState("");
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [company, setCompany] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  // Add a function to handle page change
  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };

  // Add a function to handle page size change
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };
  const [rowAddData, setRowAddData] = useState({
    doc_name: "",
    doc_type: "",
    doc_renewal_dt: "",
    doc_reminder_before: "",
    doc_file_name: "",
    mail_to: "",
    comapnay_id: "",
  });

  const [filterCriteria, setfilterCriteria] = useState({
    doc_name: "",
    doc_type: "",
    doc_renewal_dt: "",
    doc_reminder_before: "",
  });

  const formRef = useRef(null);
  // console.log("rowData", rowAddData)

  const setimgfile = (e) => {
    setFile(e.target.files[0]);
  };

  const handleFilterChange = (name, value) => {
    setfilterCriteria(() => {
      return {
        ...setfilterCriteria,
        [name]: value,
      };
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setselectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("doc_file", file);
    formData.append("doc_name", rowAddData.doc_name);
    formData.append("doc_type", rowAddData.doc_type);
    formData.append("doc_renewal_dt", rowAddData.doc_renewal_dt);
    formData.append("doc_reminder_before", rowAddData.doc_reminder_before);
    formData.append("mail_to", rowAddData.mail_to);
    formData.append("company_id", rowAddData.comapnay_id);

    let BASE_URL = SERVER_URL + `/api/compliance/document/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getData = async () => {
    // Filter out empty or undefined values from filterCriteria
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );

    // Construct the query string dynamically
    const queryString = new URLSearchParams({
      company_id: selectedCompanyId || "",
      skip: currentPage,
      take: pageSize,
      ...nonEmptyFilterCriteria, // Spread the filtered criteria into the query string
    }).toString();

    const BASE_URL = `${SERVER_URL}/api/compliance/document/search/${user_id}?${queryString}`;

    try {
      const res = await fetch(BASE_URL, {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (res.ok) {
        const result = await res.json();
        setTotalRecords(result.total);
        setRowData(
          result.data.map((item, index) => {
            return {
              ...item,
              doc_renewal_dt: moment(item.doc_renewal_dt).format("YYYY-MM-DD"),
            };
          })
        );

        // Hide overlay if gridRef is defined
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.hideOverlay();
        }
      } else {
        setRowData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setRowData([]);
    }
  };

  let check = true;
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);
  useEffect(() => {
    if (check) {
      if (loadingOverlayVisible) {
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.showLoadingOverlay();
        }
      }
      setLoadingOverlayVisible(true);
      const fecthDebounced = _.debounce(getData, 500);
      fecthDebounced();
      return () => {
        fecthDebounced.cancel();
      };
    }
    check = false;
  }, [filterCriteria, currentPage, pageSize]);

  const updateData = async (rowData) => {
    const {
      id,
      doc_name,
      doc_type,
      doc_renewal_dt,
      doc_reminder_before,
      mail_to,
    } = rowData;
    const renewalDate = moment.utc(doc_renewal_dt, "YYYY-MM-DD").toISOString();

    let BASE_URL = SERVER_URL + `/api/compliance/document/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        doc_name,
        doc_type,
        doc_renewal_dt: renewalDate,
        doc_reminder_before,
        mail_to,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      // getData();
    } else {
      toast.error(response.message);
      // getData();
    }
  };

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
    // window.alert("selection changed, " + rowCount + " rows selected");
  }, []);

  const deleteSelectedRows = () => {
    setRowData((prevData) =>
      prevData.filter((row) => !selectedRows.includes(row))
    );
    // Clear the selection after deletion
    setSelectedRows([]);
  };

  const deleteRow = async (id) => {
    let BASE_URL = SERVER_URL + `/api/compliance/document/${user_id}`;
    const message = "Do you want to delete this document!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
          // Retain the existing filter criteria values
        };
      });
    }
  };

  const addDataToModal = async (rowData) => {
    setselectedRowsData(rowData);
  };

  const handleDownload = async (doc_id) => {
    let BASE_URL = `${SERVER_URL}/api/compliance/document/${user_id}/${doc_id}`;
    const response = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const blob = await response.blob();

      // Use a default filename or extract it from the response headers
      const filename = response.headers.get("content-disposition")
        ? response.headers.get("content-disposition").split("filename=")[1]
        : "default-filename";

      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } else {
      console.error("Failed to download file");
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyChange = (e) => {
    const companyId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectedCompanyId(companyId);

    // Update filterCriteria with the selected company's ID
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));
  };

  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => {
        const currentPageContext = params.context.currentPage;
        const pageSizeContext = params.context.pageSize;
        return (
          (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
        );
      },
      width: 100,
      minWidth: 100,
      // headerCheckboxSelection: true,
      // checkboxSelection: true,
    },
    {
      headerName: "Company Name",
      field: "companyDetails.company_name",
      valueFormatter: (params) => {
        const location = params.data.companyDetails.location;
        // const type = params.data.company.type;
        return `${params.value}, ${location}`;
      },
      editable: false,
      minWidth: 250,
    },
    {
      headerName: "Document Name",
      field: "doc_name",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Document Type",
      field: "doc_type",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Document Renewal Date",
      field: "doc_renewal_dt",
      editable: true,
      minWidth: 205,
      cellEditor: "agDateStringCellEditor",
    },
    {
      headerName: "Document Reminder Before",
      field: "doc_reminder_before",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Mail",
      field: "mail_to",
      editable: true,
      minWidth: 205,
    },
    {
      headerName: "Actions",
      editable: false,
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => deleteRow(params.data.id)}
          >
            <i className="mdi mdi-delete" />
          </button>{" "}
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => addDataToModal(params.data)}
            data-toggle="modal"
            data-target="#updateModal"
          >
            <i className="mdi mdi-note-edit-outline" />
          </button>
          <button
            className="btn btn-outline-dark btn-sm ml-1"
            onClick={() => handleDownload(params.data.id)}
          >
            <i className="mdi mdi-download" />
          </button>
        </>
      ),
      minWidth: 205,
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: true,
    flex: 1,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
    setfilterCriteria({
      doc_name: "",
      doc_type: "",
      doc_renewal_dt: "",
      doc_reminder_before: "",
    });
    setSelectedCompanyId("");
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Compliances Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>

          <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add Compliances
              </button>
            </div>

            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>

          <div className="search mb-3">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control form-control-lg"
                    onChange={handleCompanyChange}
                    value={selectedCompanyId}
                  >
                    <option value="">Select Company (All)</option>
                    {company &&
                      company?.length > 0 &&
                      company?.map((item, id) => {
                        return (
                          <React.Fragment key={id}>
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.company_name}, ${item.location}`}</option>
                          </React.Fragment>
                        );
                      })}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Search by document name"
                  onChange={(e) =>
                    handleFilterChange("doc_name", e.target.value)
                  }
                  value={filterCriteria.doc_name}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Search by document type"
                  onChange={(e) =>
                    handleFilterChange("doc_type", e.target.value)
                  }
                  value={filterCriteria.doc_type}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control form-control-lg"
                  placeholder="Search by document type"
                  onChange={(e) =>
                    handleFilterChange("doc_renewal_dt", e.target.value)
                  }
                  value={filterCriteria.doc_renewal_dt}
                />
              </div>
            </div>
          </div>
          <div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                context={{ currentPage, pageSize }}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>
          <AddDataModal
            handleChange={handleChange}
            setimgfile={setimgfile}
            handleAddDataSubmit={handleAddDataSubmit}
            formRef={formRef}
            file={file}
            getData={getData}
          />
          <UpdateDataModal
            selectedRowsData={selectedRowsData}
            setselectedRowsData={setselectedRowsData}
            updateHandleChange={updateHandleChange}
            getData={getData}
            // setimgfile={setimgfile}
            // file={file}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default Compliances;
